import { render } from "./FooterLogo.vue?vue&type=template&id=4d902f56&scoped=true&ts=true"
import script from "./FooterLogo.vue?vue&type=script&lang=ts"
export * from "./FooterLogo.vue?vue&type=script&lang=ts"

import "./FooterLogo.vue?vue&type=style&index=0&id=4d902f56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d902f56"]])

export default __exports__